function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { forEach } from 'lodash-es';
import SpzaComponent from '@shared/components/spzaComponent';
import { Constants } from '@shared/utils/constants';
import { routes } from '@shared/routerHistory';
import { Sitemap } from '@shared/components/sitemap/sitemap';
import appsourceHomeBanner from '@shared/images/homepage/AppSourceBanner.jpeg';
export class AppSourceSitemap extends SpzaComponent {
    componentDidMount() {
        const sitemapSectionDetails = [
            this.getRootSitemapSection(),
            this.getAppsSitemapSection(),
            this.getServicesSitemapSection()
        ];
        this.setState({
            sitemapSectionsDetails: sitemapSectionDetails,
            sectionDidMount: true
        });
    }
    getRootSitemapSection() {
        const title = this.context.loc('Sitemap_AppSourceRootTitle', 'AppSource');
        const columns = this.getRootColumns();
        return {
            title,
            columns
        };
    }
    getRootColumns() {
        const firstColumn = {
            title: this.context.loc('Sitemap_AppSourceStore', 'AppSource Store'),
            linkList: [
                {
                    title: this.context.loc('Sitemap_AppSourceStore', 'AppSource Store'),
                    url: this.context.buildHref(routes.home, {}, {})
                }
            ]
        };
        const secondCoulumn = {
            title: this.context.loc('App_Support'),
            linkList: [
                {
                    title: this.context.loc('Appsource_Header_Blog'),
                    url: this.context.buildHref(routes.blog, {}, {})
                },
                {
                    title: this.context.loc('Appsource_Header_Sell'),
                    url: this.context.buildHref(routes.marketplacePartners, {}, {})
                },
                {
                    title: this.context.loc('Purchase_In_AppSource'),
                    url: Constants.purchaseInAppSourceLink,
                    isExternal: true
                },
                {
                    title: this.context.loc('Help_Support'),
                    url: Constants.appSourceContactUsLink,
                    isExternal: true
                }
            ]
        };
        return [
            firstColumn,
            secondCoulumn
        ];
    }
    getServicesSitemapSection() {
        const title = this.context.loc('Appsource_Header_Consulting_Services');
        const rootLinks = this.getServicesRootLinks();
        const columns = this.getServicesColumns();
        return {
            title,
            rootLinkList: rootLinks,
            columns
        };
    }
    getServicesRootLinks() {
        return {
            linkList: [
                {
                    title: this.context.loc('Sitemap_ServicesGalleryLink', 'Consulting Services gallery'),
                    url: this.context.buildHref(routes.marketplaceServices, null, {})
                }
            ]
        };
    }
    getServicesColumns() {
        const industryLinkList = [];
        const productLinkList = [];
        forEach(this.props.servicesDatamap.industries, (dataValue)=>{
            industryLinkList.push({
                title: this.context.loc(dataValue.LocKey, dataValue.Title),
                url: this.context.buildHref(routes.marketplaceServices, null, {
                    industry: dataValue.UrlKey
                })
            });
        });
        forEach(this.props.servicesDatamap.products, (dataValue)=>{
            if (dataValue.Level === 1) {
                productLinkList.push({
                    title: this.context.loc(dataValue.LocKey, dataValue.Title),
                    url: this.context.buildHref(routes.marketplaceServices, null, {
                        product: dataValue.UrlKey
                    })
                });
            }
        });
        const firstColumn = {
            title: this.context.loc('FilterType_Industries'),
            linkList: industryLinkList.sort()
        };
        const secondColumn = {
            title: this.context.loc('FilterType_Products'),
            linkList: productLinkList.sort()
        };
        return [
            firstColumn,
            secondColumn
        ];
    }
    getAppsRootLinks() {
        const firstLink = {
            title: this.context.loc('Sitemap_AppsGalleryLink', 'Apps gallery'),
            url: this.context.buildHref(routes.marketplace, {}, {})
        };
        return {
            linkList: [
                firstLink
            ]
        };
    }
    getAppsSitemapSection() {
        const title = this.context.loc('Appsource_Header_Apps');
        const rootLinks = this.getAppsRootLinks();
        const columns = this.getAppsColumns();
        return {
            title,
            rootLinkList: rootLinks,
            columns
        };
    }
    getAppsColumns() {
        const categoryLinkList = [];
        const industryLinkList = [];
        const productLinkList = [];
        const categories = this.props.appsDatamap.categories.default;
        forEach(categories, (dataValue)=>{
            categoryLinkList.push({
                title: this.context.loc(dataValue.LocKey, dataValue.Title),
                url: this.context.buildHref(routes.marketplace, null, {
                    category: dataValue.UrlKey
                })
            });
        });
        forEach(this.props.appsDatamap.industries, (dataValue)=>{
            industryLinkList.push({
                title: this.context.loc(dataValue.LocKey, dataValue.Title),
                url: this.context.buildHref(routes.marketplace, null, {
                    industry: dataValue.UrlKey
                })
            });
        });
        forEach(this.props.appsDatamap.products, (dataValue)=>{
            if (dataValue.Level === 1 || dataValue.Level === 2) {
                productLinkList.push({
                    title: this.context.loc(dataValue.LocKey, dataValue.Title),
                    url: this.context.buildHref(routes.marketplace, null, {
                        product: dataValue.UrlKey
                    })
                });
            }
        });
        return [
            {
                title: this.context.loc('FilterType_Categories'),
                linkList: categoryLinkList
            },
            {
                title: this.context.loc('FilterType_Industries'),
                linkList: industryLinkList
            },
            {
                title: this.context.loc('FilterType_Products'),
                linkList: productLinkList
            }
        ];
    }
    renderImpl() {
        return /*#__PURE__*/ _jsx(Sitemap, {
            sitemapSectionsDetails: this.state.sitemapSectionsDetails,
            bannerDetails: this.sitemapBanner
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "sitemapBanner", void 0);
        this.sitemapBanner = {
            data: {
                title: context.loc('Sitemap_AppsourceBannerText', 'AppSource Site Map'),
                description: '',
                imgURL: appsourceHomeBanner
            }
        };
        this.state = {
            sectionDidMount: false,
            sitemapSectionsDetails: []
        };
    }
}
AppSourceSitemap.contextTypes = {
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func,
    loc: PropTypes.func
};
